/* eslint-disable */
/* global PAYPAL */
'use strict'

var querystring = require('querystring'),
  _merge = require('lodash.merge')

var isScriptLoaded = false,
  pendingTrackQueue = []

function appendToBody(element) {
  window.document.body.appendChild(element)
}

var Track = {
  initialize: function (data) {
    var result = loadTrackingLibrary(data)

    result.then(function () {
      pendingTrackQueue.reduce(function (prev, curr) {
        return prev.then(curr)
      }, result)
    })
  },

  track: function (data, delay) {
    if (!isScriptLoaded) {
      Track._addPendingTrackPromise(data, delay)
      return
    }

    Track._track(data)
  },

  _addPendingTrackPromise: function (data, delay) {
    pendingTrackQueue.push(function () {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          Track._track(data)
          resolve()
        }, delay)
      })
    })
  },

  _track: function (data) {
    window.fpti = _merge(window.fpti, data)

    if (typeof window.PAYPAL.analytics != 'undefined') {
      window.PAYPAL.pta = window.PAYPAL.analytics.setup()
    }
  },
}

function pageview(pageName, data) {
  Track.track(_merge({ page: pageName }, data || {}))
}

// only relevant for pages rendered on the server
function getNoScriptImgBeacon(data) {
  var noscript = window.document.createElement('noscript')

  noscript.innerHTML = `<img src="https://t.paypal.com/ts?nojs=1&${querystring.stringify(data)}" alt="" height="1" width="1" border="0" />`

  return noscript
}

function loadTrackingLibrary(data) {
  return new Promise(function (resolve, reject) {
    var script = window.document.createElement('script')
    script.async = 1
    script.src = '//www.paypalobjects.com/pa/js/min/pa_thirdparty.js'

    script.onload = function () {
      isScriptLoaded = true
      resolve()
    }

    appendToBody(script)
    appendToBody(getNoScriptImgBeacon(data))
  })
}

module.exports = {
  initialize: Track.initialize,
  pageview: pageview,
}